import { v4 as uuid } from "uuid";
import {Model} from "./base/Model";
import {Collection} from "./base/Collection";
import { Worklog } from "./Worklog";

    export class Sector extends Model  {
        children: Collection = new Collection();
        enabled:Boolean = true;
                 
        constructor(data = null) {
            super(data);
            if(data) {
                if(data["children"]) {
                    this["children"] = new Collection(data["children"], Sector);
                    }
                
                this.createModel(data, {children: Sector});
            }
            
//            if(data.worklog && data.worklog.logs && Array.isArray(this["worklog"]["logs"])) {
//                this["worklog"]["logs"] = new Collection(data.worklog.logs);
//            }
        }      

        public getKeyName() {
            let key = this['key'];
            let keyName = 'key';
            if(!key) {
                keyName = 'ref';
            }
            return keyName;
        }
        
        public getKey() {
            let key = this[this.getKeyName()];
            return key;
        }
        
        public getChildrenForState(keyName = "state", key) {
            let tasks = [];
                if(this.children instanceof Collection && this.children.length > 0) {
                    tasks = this.children.where(keyName, key).get();
                }
            return tasks;
            }
        
        public getTaskByKey(key, keyName = "ref") {
            let task = null;
            if(this[keyName] && this[keyName].trim() == key.trim()) {
                task = this;
            } else {
                if(this.children instanceof Collection && this.children.length > 0) {
                    task = this.children.findChildByKey(key, keyName);
                }
            }
            return task;
        }      
        
              
    }